/**
 * number-counter.js
 * 
 * 功能：将数字（如 1000000）格式化为带逗号的字符串（如 "1,000,000"），
 * 并且在元素进入可视区域时，实现从 0 平滑递增到目标数字的动画效果。
 * 
 * 使用方法：
 * 在需要显示数字的 HTML 元素上添加 `class="number-counter"` 和 `data-target="目标数字"` 即可。
 * 例如：<span class="number-counter" data-target="1000000">0</span>
 */

(function() {
    const initCounters = () => {
      // 默认动画持续时间（毫秒），你可以根据需要修改
      const defaultDuration = 2000; 
  
      const animateCounter = (el) => {
        // 获取目标数值
        const target = parseInt(el.getAttribute('data-target'), 10);
        if (isNaN(target)) return;
        
        // 获取自定义的动画时间，如果没有则使用默认值
        const duration = parseInt(el.getAttribute('data-duration'), 10) || defaultDuration;
  
        let startTimestamp = null;
        
        const step = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;
          // 计算当前进度 (0 到 1 之间)
          const progress = Math.min((timestamp - startTimestamp) / duration, 1);
          
          // 使用 easeOut 缓动函数，让数字递增的效果“先快后慢”，看起来更自然
          const easeProgress = 1 - Math.pow(1 - progress, 3);
          const currentVal = Math.floor(easeProgress * target);
          
          // 使用 toLocaleString() 自动为数字添加千分位逗号
          el.innerText = currentVal.toLocaleString();
          
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            // 动画结束，确保最终数字完全准确
            el.innerText = target.toLocaleString();
          }
        };
        
        // 开始动画帧循环
        window.requestAnimationFrame(step);
      };
  
      // 初始化 Intersection Observer，监听元素是否进入可视区域
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 // 元素有 10% 进入可视区域时就触发
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            // 动画执行一次后，取消对该元素的观察以提升性能
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
  
      // 查找所有带有 .number-counter 类的元素并开始观察
      const counters = document.querySelectorAll('.number-counter');
      counters.forEach(counter => {
        // 初始状态显示为 0
        counter.innerText = '0';
        observer.observe(counter);
      });
    };
  
    // 确保在 DOM 加载完成后执行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCounters);
    } else {
      initCounters();
    }
  })();
  